import { FC } from 'react';
import { Button } from '@/components/ui/button';
import {
  ExecuteDeviceFunctionQueryArg,
  useExecuteDeviceFunctionMutation,
} from '@/redux/api/endpoints/device-functions';
import { AlexaFunctionCard } from './alexa-function-card';
import { AlexaFunctionResult } from './alexa-function-result';

type ReadAlexaFunctionProps = {
  title: string;
  description: string;
  buttonLabel: string;
  request?: Extract<
    ExecuteDeviceFunctionQueryArg,
    { function: 'get-device' | 'get-room' }
  >;
  disabledReason?: string;
};

export const ReadAlexaFunction: FC<ReadAlexaFunctionProps> = ({
  buttonLabel,
  description,
  disabledReason,
  request,
  title,
}) => {
  const [execute, { data, error, isLoading }] =
    useExecuteDeviceFunctionMutation();

  return (
    <AlexaFunctionCard description={description} title={title}>
      <Button
        disabled={!request || isLoading}
        onClick={() => {
          if (request) {
            void execute(request);
          }
        }}
        type="button"
        variant="secondary"
      >
        {buttonLabel}
      </Button>
      {disabledReason && (
        <p className="mt-2 text-xs text-gray-500">{disabledReason}</p>
      )}
      <AlexaFunctionResult data={data} error={error} isLoading={isLoading} />
    </AlexaFunctionCard>
  );
};
